import { IDirectory } from "../Models/File";

export function hasWriteAccessToSharedMyLibraryFolder(
    directory: IDirectory | undefined,
    userId: number | undefined,
    options?: { noCheckRoot?: boolean }
): boolean {
    return !!(directory && (options?.noCheckRoot || directory.paths.length > 1) && userId && directory.writeAccessIds.includes(userId));
}
